export const initialPlayerState = {
  id: null,
  email: null,
  pseudo: null,
  avatar: null,
  quizId: null,
};

export const playerReducer = (state = initialPlayerState, action) => {
  switch (action.type) {
    case "SET_PLAYER":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
